import type { EffectSection } from './sections';

const sameParams = (a: EffectSection['params'], b: EffectSection['params']) =>
  a?.speed === b?.speed && a?.frequency === b?.frequency;

/** Merge an edit into a section. A patch without `params` keeps the section's
 *  own. Returns null when nothing would change (e.g. a slider thumb released
 *  on its current value), so the caller spends no undo entry and no save. */
export function applyEffectSectionPatch(section: EffectSection, patch: Partial<EffectSection>): EffectSection | null {
  const next: EffectSection = { ...section, ...patch, params: patch.params ?? section.params };
  const unchanged = next.id === section.id
    && next.effect === section.effect
    && next.start === section.start
    && next.end === section.end
    && next.intensity === section.intensity
    && next.ease === section.ease
    && sameParams(next.params, section.params);
  return unchanged ? null : next;
}
